const INITIAL_STATE = {
    data: null
}

const TitleReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'title': {

            return {
                ...state,
                data: action.payload.title
            }
        }
        default: {
            return state
        }
    }
}

export default TitleReducer